import { useState, useEffect, useRef } from "react";
import "./range-slider.scss";

export function RangeSlider({ min, max, value, step, onChange, active }) {
    const [rangeValue, setRangeValue] = useState(value ? value.min : min);
    const rangeRef = useRef(null);

    useEffect(() => {
        if (value) {
            setRangeValue(value);
        }
    }, [value]);

    const handleChange = e => {
        e.preventDefault();
        const newVal = +e.target.value;
        if (!value) setRangeValue(newVal);
        onChange(newVal);
    };

    const changeInputValue = e => {
        let bounds = rangeRef.current.getBoundingClientRect();
        let x = e.clientX - bounds.left;
        let y = e.clientY - bounds.top;
        const percent = Math.round((x * 100) / bounds.width);
        const newValue = Math.ceil(max * (percent / 100));
        setRangeValue(newValue);
        onChange(newValue);
    };

    const valuePosition = ((rangeValue - min) / (max - min)) * 100;

    const separatorSize = parseInt(max) / parseInt(step);

    return (
        <div className="range-slider">
            <div className="input-wrapper">
                <input className="input" type="range" value={rangeValue} min={min} max={max} step={step} onChange={handleChange} />
            </div>

            <div className="control-wrapper">
                <div className="control" id="control" style={{ left: `${valuePosition - 2}%` }} />
                <div className="rail" onClick={active ? changeInputValue : () => {}} ref={rangeRef}>
                    {Array.from({ length: separatorSize }, (_, i) => (
                        <span className={i > 0 ? "rail__separator" : ""} style={{ position: "absolute", left: `${i * (100 / max)}%` }} key={i}></span>
                    ))}
                    <div
                        className="inner-rail"
                        style={{
                            left: `0`,
                            width: `${valuePosition}%`,
                            borderRadius: "5px",
                            background: `${
                                valuePosition === 20
                                    ? "var(--teal-color-08)"
                                    : valuePosition === 40
                                    ? "linear-gradient(to right, var(--teal-color-08) 50%, var(--teal-color-09) 100%)"
                                    : valuePosition === 60
                                    ? "linear-gradient(to right, var(--teal-color-08) 33.3333%, var(--teal-color-09) 66.66666%, var(--primary-color) 100%)"
                                    : valuePosition === 80
                                    ? "linear-gradient(to right, var(--teal-color-08) 25%, var(--teal-color-09) 50%, var(--primary-color) 75%, var(--teal-color-10) 100%)"
                                    : valuePosition === 100
                                    ? "linear-gradient(to right, var(--teal-color-08) 20%, var(--teal-color-09) 40%, var(--primary-color) 60%, var(--teal-color-10) 80%, var(--teal-color-11) 100%)"
                                    : ""
                            }`,
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default RangeSlider;
